import Vue from "vue";
// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap-vue/dist/bootstrap-vue.css';
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueCarousel from "vue-carousel";
import vuetify from "./plugins/vuetify";
import ax from "./plugins/axios";
import ActivityIndicator from 'vue-activity-indicator';

Vue.prototype.$http = ax;
Vue.use(VueCarousel);
Vue.use(ActivityIndicator);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
